import { useTheme } from "styled-components";

// Live "used/max" character counter shown under a length-limited field
const CharCounter = ({ value, max, style }) => {
  const theme = useTheme();
  const count = String(value ?? "").length;

  return (
    <div
      aria-live="polite"
      style={{
        fontSize: 12,
        marginTop: 4,
        textAlign: "end",
        color: count > max ? theme.color.error : "#9FA2B4",
        ...style,
      }}
    >
      {count}/{max}
    </div>
  );
};

export default CharCounter;
